module.exports = __webpack_public_path__ + "img/malaysia-flag.ce611e06.png";